import { useCallback, useEffect, useState } from "react";

/**
 * Solo administrador: ver la web como visitante sin cerrar sesión.
 * Es una preferencia visual en este navegador; nunca concede ni quita permisos
 * (los permisos siguen saliendo del servidor).
 */
const KEY = "rl-admin-guest-preview";
const EVENT = "rl-admin-guest-preview-change";

const read = () => {
  try { return window.localStorage.getItem(KEY) === "1"; } catch { return false; }
};

export function setAdminGuestPreview(on: boolean) {
  try {
    if (on) window.localStorage.setItem(KEY, "1");
    else window.localStorage.removeItem(KEY);
  } catch { /* ignore */ }
  window.dispatchEvent(new Event(EVENT));
  window.dispatchEvent(new Event("rl:assistant-changed"));
}

export function useAdminGuestPreview(enabled = true): boolean {
  const [on, setOn] = useState(false);
  useEffect(() => {
    if (!enabled) { setOn(false); return; }
    const sync = () => setOn(read());
    sync();
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, [enabled]);
  return enabled && on;
}

export const useSetAdminGuestPreview = () => useCallback(setAdminGuestPreview, []);
